import {SymbolPosition} from '@gongxigames/framework/slot/utils';

export type ReelsCascadingMoveData = {
    delay: number;
    fromCoordinates: SymbolPosition;
    toCoordinates: SymbolPosition;
};

export type HitAnimationData = {
    spineName: string;
    animationName: string;
};

export type ReelsCascadingAddData = {
    symbolID: number;
    coordinates: SymbolPosition;
};